import { FC, ReactElement } from 'react';

import { TalentsCard } from '../../../containers';
import { useTypedSelector } from '../../../redux/store';

interface ConnectedTalentsCardProps {
    onRefresh: () => void;
    className?: string;
}

const ConnectedTalentsCard: FC<ConnectedTalentsCardProps> = ({
    onRefresh,
    className = '',
}): ReactElement => {
    const user = useTypedSelector(state => state.userReducer.user);
    const candidate = useTypedSelector(state => state.candidateReducer.candidate);

    const skillsPassportIsLoading = useTypedSelector(state => state.skillsPassportReducer.isLoading);
    const talents = useTypedSelector(state => state.skillsPassportReducer.talents);
    const isUpToDate = useTypedSelector(state => state.skillsPassportReducer.isUpToDate);

    return (
        <TalentsCard
            isLoading={skillsPassportIsLoading}
            isUpToDate={isUpToDate}
            candidateUuid={candidate?.uuid}
            userRoles={user?.roles}
            talents={talents}
            handleRefresh={onRefresh}
            className={className}
        />
    );
};

export default ConnectedTalentsCard;
